
import Vue from 'vue';

/**
 * Skeleton / Placeholder.
 *
 * Placeholder template for loading.
 */
export default Vue.extend({
  props: {
    /**
     * Height of the skeleton.
     */
    height: {
      type: String,
      default: '16px'
    },
    /**
     * Width of the skeleton.
     */
    width: {
      type: String,
      default: '96px'
    }
  },
  computed: {
    skeletonDimension() {
      return {
        // @ts-ignore Vue being vue
        height: this.appendPxToString(this.height),
        // @ts-ignore Vue being vue
        width: this.appendPxToString(this.width)
      };
    }
  },
  methods: {
    appendPxToString(str: string) {
      const isPx = str.indexOf('px') >= 0;
      const isPercent = str.indexOf('%') >= 0;

      return isPx ? str : isPercent ? str : `${str}px`;
    }
  }
});
